import { Button, Center, Text } from '@chakra-ui/react'
import React from 'react'
import { useTranslations } from 'next-intl'
import { Link } from '@/i18n/navigation'

export default function RecipeEmptyState() {
  const t = useTranslations()
  return (
    <Center flexDir='column' minH='80vh'>
      <Text fontWeight={600} fontSize='xl' mt={4} mb={2}>
        {t('no_recipes_yet')}
      </Text>
      <Text mb={4} color='text.muted' textAlign='center' maxW='450px'>
        {t('new_recipes_soon')}
      </Text>
      <Link href={'/'}>
        <Button
          bg='primary'
          color='primary.text'
          _hover={{
            bg: 'primary.hover',
          }}
          size={'xl'}
          rounded={16}
          height={'56px'}
        >
          {t('back_to_home')}
        </Button>
      </Link>
    </Center>
  )
}
